export const DOCUMENT_ITEM_CLASS = 'document-item';
export const DOCUMENT_ITEM_WRAPPER_CLASS = 'document-item-wrapper';
export const ACTION_TYPES = {
  dropdown: 'dropdown',
  download: 'download',
  redirect: 'redirect',
};
export const ACTION_ICONS_MAP = {
  [ACTION_TYPES.dropdown]: 'arrow5_step',
  [ACTION_TYPES.download]: 'action_download_stroke',
  [ACTION_TYPES.redirect]: 'body_eye',
};
